import { render, staticRenderFns } from "./DescriptionName.vue?vue&type=template&id=e0ec19a6&"
import script from "./DescriptionName.vue?vue&type=script&lang=js&"
export * from "./DescriptionName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports